import { render } from "./DeletedOrderStatus.vue?vue&type=template&id=33d40240&scoped=true"
import script from "./DeletedOrderStatus.vue?vue&type=script&lang=js"
export * from "./DeletedOrderStatus.vue?vue&type=script&lang=js"

import "./DeletedOrderStatus.vue?vue&type=style&index=0&id=33d40240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d40240"]])

export default __exports__